import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
      withoutAnimation: false
    },
    device: 'desktop',
    language: Cookies.get('language') || 'zh-CN',
    size: Cookies.get('size') || 'medium',
    tenantAvatar: '',
    displayLayout: +Cookies.get('displayLayout') || 1,
     //当前选中的一级菜单的id,用于显示相应子菜单,当没有配置菜单时为null
     selectMenuId: null,
  },
  mutations: {
    // 开关左边菜单，1:开，0:关
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 0)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_SIZE: (state, size) => {
      state.size = size
      Cookies.set('size', size)
    },
    SET_TENANT_AVATAR: (state, tenantAvatar) => {
      state.tenantAvatar = tenantAvatar
    },
    // 显示布局
    SET_DISPLAY_LAYOUT: (state, displayLayout) => {
      state.displayLayout = displayLayout
      Cookies.set('displayLayout', displayLayout)
    },
    SET_SELECT_MENU_ID: (state,param) =>{
      const key = param
      state.selectMenuId=key
  },
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setSize({ commit }, size) {
      commit('SET_SIZE', size)
    },
    ChangeTenantAvator({ commit }, tenantAvatar) {
      commit('SET_TENANT_AVATAR', tenantAvatar)
    },
    setDisplayLayout({ commit }, displayLayout) {
      commit('SET_DISPLAY_LAYOUT', displayLayout)
    },
  }
}

export default app
